import useAuthUser from "@forwardflow/hooks/customHooks/useAuthUser";
import ConversationsPage from "@forwardflow/pages/Conversations";
import NotFound from "@forwardflow/pages/NotFound";

const ConversationLayout = () => {
  const { data: user, isLoading } = useAuthUser({ revalidateOnMount: true });

  if (isLoading || !user) {
    return null;
  }

  const allowedEmails = [
    'operator@forward-flow.com',
    'brannon@forward-flow.com',
    'engineered@forward-flow.com'
  ];

  const hasAccess = allowedEmails.includes(user.email);

  return hasAccess ? (<ConversationsPage />) : <NotFound />;
};

export default ConversationLayout;